export enum variantOptions {
  line = "line",
  "soft-rounded" = "soft-rounded",
}

export enum tabVariantOptions {
  icon = "icon",
}
